module.exports = __webpack_public_path__ + "img/ic_check.53a3b6fc.svg";